import { takeLatest, put, call } from "redux-saga/effects"
import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE } from "./actionTypes"
import { signupSuccess, signupFailure } from "./actions"
import API from "../../../api/axios"
import { toast } from "react-toastify"

function* signup(action) {
  try {
    // console.log("Signup Payload:", action.payload)

    const response = yield call(
      API.post,
      "/users/auth/signup",
      action.payload,
    )

    console.log("API Response:", response)

    if (response.status === 200 || response.status === 201) {
      // toast.success("Registered Successfully!", { autoClose: 2000 })
      // console.log("Signup successful, user data:", response.data)

      yield put(
        signupSuccess({
          user: response.data,
          message: "User registered successfully",
        }),
      ) // Dispatch success action
    } else {
      console.log("Unexpected response structure:", response)
      yield put(signupFailure("Unexpected response from server"))
    }
  } catch (error) {
    console.error("Signup Error:", error)
    yield put(signupFailure(error.response?.data?.message || "Signup failed"))
  }
}

export function* watchSignupSaga() {
  yield takeLatest(SIGNUP_REQUEST, signup)
}

export default watchSignupSaga
